var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackOther(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13582_67892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.8496C13.2279 15.8496 16.25 12.8275 16.25 9.09961C16.25 5.37169 13.2279 2.34961 9.5 2.34961C5.77208 2.34961 2.75 5.37169 2.75 9.09961C2.75 12.8275 5.77208 15.8496 9.5 15.8496Z",
    stroke: "#42296E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.94336C9.96599 9.94336 10.3438 9.5656 10.3438 9.09961C10.3438 8.63362 9.96599 8.25586 9.5 8.25586C9.03401 8.25586 8.65625 8.63362 8.65625 9.09961C8.65625 9.5656 9.03401 9.94336 9.5 9.94336Z",
    fill: "#42296E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.875 9.94336C13.341 9.94336 13.7188 9.5656 13.7188 9.09961C13.7188 8.63362 13.341 8.25586 12.875 8.25586C12.409 8.25586 12.0312 8.63362 12.0312 9.09961C12.0312 9.5656 12.409 9.94336 12.875 9.94336Z",
    fill: "#42296E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.125 9.94336C6.59099 9.94336 6.96875 9.5656 6.96875 9.09961C6.96875 8.63362 6.59099 8.25586 6.125 8.25586C5.65901 8.25586 5.28125 8.63362 5.28125 9.09961C5.28125 9.5656 5.65901 9.94336 6.125 9.94336Z",
    fill: "#42296E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13582_67892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.0996094)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackOther);
export default __webpack_public_path__ + "static/media/feedback-other.b489687a39f6fb4637fbf9303f66d95b.svg";
export { ForwardRef as ReactComponent };